<div class="card">
    <h1>This module will <span>unlock soon</span></h1>
    
    <p>
      You’re making great progress! This module will become available 
      as you move ahead in your program or when it’s scheduled to be released. 
      In the meantime, continue with the modules that are currently open to you.
    </p>

    <a href="/dashboard" class="btn-cta">
      BACK TO DASHBOARD
      <span class="icon">→</span>
    </a>
  </div>